import { CRField } from '@smart-builder/types';
import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRGlassTypeBody,
  CRGlassTypeBodyAPI,
  CRGlassTypeKey,
  CRGlassTypeSummary,
  CRGlassTypeSummaryAPI,
  GlassTypesActions,
  GlassTypesState,
  Scope,
} from './types';

type AnyGlassType =
  | CRGlassTypeKey
  | CRGlassTypeSummary
  | CRGlassTypeBody
  | undefined;

function sameKeyGlassType(a: AnyGlassType, b: AnyGlassType): boolean {
  return a?.glassTypeId === b?.glassTypeId;
}

function getEndpointGlassType(key: AnyGlassType): string {
  return key ? `/glass-types/${key.glassTypeId}/` : '/glass-types/';
}

function parseGlassTypeSummary(
  glassTypeSummary: CRGlassTypeSummaryAPI,
): CRGlassTypeSummary {
  const { opacity, ...rest } = glassTypeSummary;
  return {
    ...rest,
    opacity: +opacity,
  };
}

function parseGlassTypeBody(
  glassTypeDetail: CRGlassTypeBodyAPI,
): CRGlassTypeBody {
  return glassTypeDetail;
}

const glassTypesStateSelector = (state: any): GlassTypesState =>
  state.glassTypes;

const glassTypesKeySelector = ({
  glassTypeId,
}: CRGlassTypeBody | CRGlassTypeSummary): CRGlassTypeKey => ({ glassTypeId });

function mergeGlassTypeBody(
  lastBody: CRGlassTypeBody,
  currentBody: CRGlassTypeBody,
) {
  return currentBody;
}

function combineSummaryBodyGlassType(
  summary?: CRGlassTypeSummary,
  body?: CRGlassTypeBody,
): CRGlassTypeSummary {
  const merge = mergeSummaryBodyField(summary, body);
  const override = body?.detailsOverridden?.client.value;
  function coalesceDisplayProperty<T>(
    site?: CRField<T>,
    parent?: CRField<T>,
    summary?: T,
  ) {
    if (override) {
      return site?.client.value ?? parent?.client.value ?? summary;
    } else {
      return parent?.client.value ?? summary;
    }
  }

  return {
    glassTypeId: merge('glassTypeId'),
    glassTypeName:
      body?.glassTypeName?.client.value ??
      body?.glassTypeNameDefault?.client.value ??
      summary?.glassTypeName ??
      '',
    specialSurface: merge('specialSurface'),
    inUse: merge('inUse'),
    colour3DBGR: coalesceDisplayProperty(
      body?.colour3DSiteBGR,
      body?.colour3DDefaultBGR,
      summary?.colour3DBGR,
    ),
    opacity: coalesceDisplayProperty(
      body?.opacity,
      body?.opacityDefault,
      summary?.opacity,
    )!,
    isPatterned: merge('isPatterned'),
    isTextured:
      (override
        ? body?.textureImageIdSite.client.value
        : body?.textureImageIdDefault.client.value) !== null,

    isSpandrel: body?.isSpandrel.client.value ?? summary?.isSpandrel ?? false,
    state: merge('state'),
    usage: merge('usage'),
    scope: summary?.scope ?? Scope.Local,
    rowKey: merge('rowKey'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'glassTypes',
  getEndpointGlassType,
  glassTypesStateSelector,
  sameKeyGlassType,
  parseGlassTypeBody,
  parseGlassTypeSummary,
  mergeGlassTypeBody,
  combineSummaryBodyGlassType,
  //formatGlassTypeBody,
  //validateGlassTypes,
);

const glassTypesActions: GlassTypesActions = actions;
export * from './types';
export {
  glassTypesActions,
  reducer as glassTypesReducer,
  watches as glassTypesWatches,
  glassTypesStateSelector,
  glassTypesKeySelector,
};
